import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import { token } from "functions/Helper";
import PwpList from "views/YuuPwp/PwpList";
import ViewYuuPwp from "views/YuuPwp/ViewYuuPwp";

const yuuPwp = () => {
  let views = [];

  if (token["yuu.pwps.read"] === "allowed" || token.is_admin === "True") {
    views.push({
      path: "/YuuPwp/List",
      name: "Yuu PWP",
      icon: MonetizationOnIcon,
      component: PwpList,
      layout: "/admin"
    });
  }

  if (views.length > 0) return views;
  return [];
};

const yuuPwpHidden = () => {
  let views = [];

  if (token["yuu.pwps.read"] === "allowed" || token.is_admin === "True") {
    views.push({
      path: "/YuuPwp/Detail",
      name: "Yuu PWP Detail",
      component: ViewYuuPwp,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Commission Hidden",
        state: "commissionHidden",
        hideInSidebar: true,
        views: views
      }
    ];
  return [];
};

export { yuuPwp, yuuPwpHidden };
